import { createTranslationsInstance, DEFAULT_LANGUAGE } from '@datacamp/exercise-library-translation-utils';
import { defaultIssueCategories, localizeIssueCategories } from '@datacamp/exercise-library-utils';
import commonDe from '../locales/de-DE/common.json';
import de from '../locales/de-DE/translation.json';
import commonEn from '../locales/en/common.json';
import en from '../locales/en/translation.json';
import commonEs from '../locales/es/common.json';
import es from '../locales/es/translation.json';
import commonFr from '../locales/fr-FR/common.json';
import fr from '../locales/fr-FR/translation.json';
import commonIt from '../locales/it-IT/common.json';
import it from '../locales/it-IT/translation.json';
import commonPt from '../locales/pt-BR/common.json';
import pt from '../locales/pt-BR/translation.json';
import commonTr from '../locales/tr-TR/common.json';
import tr from '../locales/tr-TR/translation.json';
import * as exercisesConstants from './exercises';
export const exercises = exercisesConstants;
const translations = {
  de: {
    common: commonDe,
    translation: de
  },
  en: {
    common: commonEn,
    translation: en
  },
  es: {
    common: commonEs,
    translation: es
  },
  fr: {
    common: commonFr,
    translation: fr
  },
  it: {
    common: commonIt,
    translation: it
  },
  pt: {
    common: commonPt,
    translation: pt
  },
  tr: {
    common: commonTr,
    translation: tr
  }
};
export const issueCategories = language => {
  const i18next = createTranslationsInstance({
    language,
    resources: translations
  });
  const categories = [{
    key: 'not-accepted-right-answer',
    value: 'My answer is correct, but it is not accepted'
  }, {
    key: 'feedback-not-helpful',
    value: 'The feedback on my submission(s) is not helpful'
  }, {
    key: 'hint-not-helpful',
    value: 'The hint is not helpful'
  }, {
    key: 'typo-ex',
    value: 'There is a typo in this exercise'
  }, ...defaultIssueCategories({
    isDefaultLanguage: language === DEFAULT_LANGUAGE
  })];
  return localizeIssueCategories(i18next, 'PureMultipleChoiceExerciseCore', categories);
};